<!-- outer node -->
<div class="table-view-header" *ngIf="dataReceived">
  <div class="thead d-flex justify-content-between" role="row">
    <div class="th d-flex" role="columnheader" *ngFor="let column of listOfColumn" [ngClass]="column.class">
      <h2 class="font-bold h-text">{{column.name}}</h2>
    </div>
  </div>
</div>
<ng-template #branch let-items>
  <div *ngFor="let item of items">
    <ng-container *ngTemplateOutlet="leaf; context: {item: item}"></ng-container>
  </div>

</ng-template>

<!-- leaf node -->
<ng-template let-item="item" #leaf>

  <div id="accordion" class="table-view">
    <div class="card">
      <div class="card-header" id="headingOne">


        <div class="tbody">
          <div class="row mx-0 tr justify-content-between" role="row" aria-live="polite" aria-atomic="true" *ngIf="item"
            [class.active]="clicked === item.id">
            <div role="rowheader" *ngFor="let column of listOfColumn" [ngClass]="column.class">
              <div *ngIf="column.propName==='full_statement'" [style.padding-left]="calculatePadding(item.level)">
                <p class="font-bold  mb-0">
                  <a href="#{{item.id}}" class="btn btn-toggle float-left"
                    [ngClass]="item.children.length===0?'last-node':''" data-toggle="collapse"
                    data-target="#{{item.id}}" aria-expanded="true" aria-controls="collapseOne">
                  </a>
                  <button class="btn btn-node font-bold" (click)="openDetails(item);" (click)="clicked = item.id">{{item[column.propName]?(item[column.propName]|
                    slice:0:charLimit):item.is_document?'Title is empty':'Full Statement is empty'}}
                    <span *ngIf="item[column.propName] && item[column.propName].length>charLimit">...</span>
                  </button>
                  <span class="controls">
                    <button *ngIf="item.hasMoreChild" class="cursor-pointer btn-icon"
                      (click)="fetchNodes(item);clicked =item.id" aria-label="view other nodes"><em
                        class="icon-ico-expand float-right ng-star-inserted"></em>
                    </button>
                    <ng-container>
                      <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 132.813 132.031" class="animated-loader" id="item.id" *ngIf="false" aria-hidden="true">
                        <path id="loader" d="M140.625,128.906a47.379,47.379,0,0,0,8.594-20.7h16.8a67.265,67.265,0,0,1-13.281,32.422ZM108.2,149.219a47.379,47.379,0,0,0,20.7-8.594l12.109,12.109A65.626,65.626,0,0,1,108.2,166.016ZM166.016,91.8h-16.8a47.379,47.379,0,0,0-8.594-20.7l12.109-11.719A60.853,60.853,0,0,1,166.016,91.8ZM91.8,50.781A49.458,49.458,0,0,0,61.914,67.773,47.949,47.949,0,0,0,50,100a47.949,47.949,0,0,0,11.914,32.227A49.458,49.458,0,0,0,91.8,149.219v16.8q-24.609-3.125-41.6-21.875A63.594,63.594,0,0,1,33.2,100,63.594,63.594,0,0,1,50.2,55.859q16.992-18.75,41.6-21.875Z" transform="translate(-33.203 -33.984)"/>
                      </svg>
                    </ng-container>
                  </span>
                </p>


              </div>
              <p class="font-bold  mb-0"
                *ngIf="column.propName!=='full_statement' && column.propName !=='compStatus' && column.propName !=='human_coding_scheme'">
                {{item[column.propName]}}</p>

              <p class="font-bold  mb-0" *ngIf="column.propName ==='human_coding_scheme'">
                {{item[column.propName] | slice:0:charLimit}}
                <span
                  *ngIf=" item[column.propName] && item[column.propName].length>charLimit && column.propName ==='human_coding_scheme'">...</span>
              </p>

              <!-- API has been commented off for the project tree image, future when it will be used needs to update the material icon -->
              <ng-container *ngIf="column.propName==='compStatus'">
                <ul class="list-inline mb-0 text-right mr-2">
                  <li class="list-inline-item"
                    *ngIf="assignedToMe === 'all' &&  item.open_comment_count > 0 && showComments">
                    <img alt="Node has comment" aria-label="Node has comment" class="img-fluid ic-edit"
                      src="assets/images/ic_msg.png">
                  </li>

                  <li class="list-inline-item"
                    *ngIf="assignedToMe === 'assignedToMe' && item.isCommented === true  && showComments">
                    <img alt="Node has comment" aria-label="Node has comment" class="img-fluid ic-edit"
                      src="assets/images/ic_msg.png">
                  </li>
                </ul>
              </ng-container>

              <ng-container *ngIf="column.propName==='edit'">
                <button class="btn btn-sm btn-primary btn-edit" *ngIf="item.hasChild === 1"
                  (click)="navigate(item.id)">Edit
                  <span class="material-icons-outlined font-4x" aria-hidden="true">edit</span>
                </button>
              </ng-container>

            </div>



          </div>
        </div>
      </div>


      <div id="{{item.id}}" class="collapse show" aria-labelledby="headingOne" [attr.data-parent]="'#'+item.id">
        <div class="card-body">
          <div class="tbody"
            *ngIf="(item['itemExemplars'] && item['itemExemplars'].length>0) || (item['itemAssets'] && item['itemAssets'].length>0) || (item['itemAssociations'] && item['itemAssociations'].length>1) ">
            <div class="row mx-0 tr justify-content-between">
              <div class="{{dynamicClass}}" [style.padding-left]="calculatePadding(item.level)">

                <div class="associated">

                </div>



              </div>
              <div *ngFor="let class of listOfClass" [ngClass]="class.class"></div>

            </div>
          </div>

          <ng-container *ngIf="item.children">
            <ng-container *ngTemplateOutlet="branch; context: { $implicit : item.children}"></ng-container>
          </ng-container>

        </div>
      </div>
    </div>

  </div>

</ng-template>
<ng-container *ngTemplateOutlet="branch; context:{ $implicit: items}">
</ng-container>


<app-tabular-tree-side-pane #tabularTreeSidePaneComponent>

</app-tabular-tree-side-pane>

<app-preloader *ngIf="!dataReceived" [loaderText]="'Loading Data..'" class="w-100 position-fixed preloader-backdrop"></app-preloader>
